var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-tabs', {
    staticClass: "tabs",
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.onTabChange
    },
    model: {
      value: _vm.currentTab,
      callback: function ($$v) {
        _vm.currentTab = $$v;
      },
      expression: "currentTab"
    }
  }, _vm._l(_vm.tabs, function (tab) {
    return _c('el-tab-pane', {
      key: tab.name,
      attrs: {
        "label": tab.name.toUpperCase(),
        "name": tab.name
      }
    }, [_c(tab, {
      tag: "component"
    })], 1);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }